<template>
  <WsCreate
    :modelName="modelName"
    :localeMode="localeMode"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
  >
  </WsCreate>
</template>

<script>
import model from "@/models/sos_request";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    localeMode: true,
    fields: model.fields,
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          hideOnNull: false,
          floors: [
            {
              fields: [
                "factory",
                "contact_person",
                "contact_way",
                "tel",
                "email",
                "contact_for",
                "remark",
                "attaches",
                "assignee",
                "status",
                "status_remark",
              ],
            },
          ],
        },
      ],
    },
  }),
};
</script>